var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import createQrCode from 'qrcode-generator';
/**
 * QrCode component.
 *
 * @event renderedToDom Triggered when component has rendered to DOM.
 */
export default class QrCode extends KompisElement {
    constructor() {
        super(...arguments);
        // A title representing the QR code both for accessibility reasons and used as a tooltip, e.g. "QR code to www.ikea.com". The title is used as a tooltip for pointing devices, and can also be read by e.g. screen readers.
        this.qrCodeTitle = null;
    }
    /**
     * Renders component.
     *
     * @returns HTML.
     */
    render() {
        return html `
			<style>
				svg {
					display: block;
					height: 100%;
					width: 100%;
					print-color-adjust: exact;
					-webkit-print-color-adjust: exact;
				}
			</style>
			${this.getQrCode()}
		`;
    }
    afterRenderToDom() {
        this.dispatchEvent(new CustomEvent('renderedToDom', { bubbles: true }));
    }
    getQrCode() {
        const qr = createQrCode(0, 'M');
        qr.addData(this.url);
        qr.make();
        const svgHtml = qr.createSvgTag({
            margin: 0,
            scalable: true
        });
        const template = document.createElement('template');
        template.innerHTML = svgHtml;
        const svg = template.content.children[0];
        if (this.qrCodeTitle) {
            const titleElement = document.createElementNS('http://www.w3.org/2000/svg', 'title');
            titleElement.textContent = this.qrCodeTitle;
            svg.prepend(titleElement);
            svg.setAttribute('role', 'img');
        }
        return svg;
    }
}
__decorate([
    property({ type: String, required: true })
], QrCode.prototype, "url", void 0);
__decorate([
    property({ type: String })
], QrCode.prototype, "qrCodeTitle", void 0);
//# sourceMappingURL=QrCode.js.map